const Pagination = ({
  currentPage,
  totalPages,
  paginate,
}) => {
  return (
    <section className="pb-24 bg-white">

      <div className="flex justify-center gap-3">

        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`w-12 h-12 rounded-xl font-semibold transition ${
              currentPage === index + 1
                ? "bg-[#082B57] text-white"
                : "bg-slate-100 text-[#082B57]"
            }`}
          >
            {index + 1}
          </button>
        ))}

      </div>

    </section>
  );
};

export default Pagination;